import React, {Component} from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";
import {GAME_SCREEN, HINTS_SCREEN} from "../../ducks/duck-screen";
import {getTranslation} from "../../helpers/get-translation";

const lightBulbImage = getTranslation("image_app_bar_hints");
const puzzleImage = getTranslation("image_app_bar_score");

const styles = theme => ({
	container: {
		display: "flex",
		alignItems: "center",
		cursor: "pointer"
	},
	number: {
		"padding-top": "3px",
		"padding-right": "5px",
		"color": "#007bff",
		"font-size":"20px",
	},
	lightBulb: {
		display: 'inline',
		width: "28px",
	},
	puzzle: {
		display: "inline",
		width: "37px"
	}
});

const shouldShowHintCount = (screen) => {
	return screen === GAME_SCREEN || screen === HINTS_SCREEN
}

class AppBarCounter extends Component{
	state = {
		isHintScreen: false,
		wasClicked: false
	};


	static getDerivedStateFromProps(props, state) {
		const newIsHintScreen = shouldShowHintCount(props.currentScreen);
		if(state.wasClicked){
			return {
				isHintScreen: state.isHintScreen,
				wasClicked: false
			}
		} else
			return {
				isHintScreen: newIsHintScreen,
				wasClicked: false
			}
	}

	onClick = () => {
		const newIsHintScreen = !this.state.isHintScreen;
		console.log(newIsHintScreen);

		this.setState({isHintScreen: newIsHintScreen, wasClicked: true})
	};



	render(){
		const { classes, hintCount, collectedRiddlesAll} = this.props;
		const isHintScreen = this.state.isHintScreen
		if(hintCount !== undefined && collectedRiddlesAll !== undefined){
			return (
				<div className={classes.container} onClick={this.onClick} >
					<span className={classes.number}>{isHintScreen ? hintCount : collectedRiddlesAll}</span>
					<img
						className={isHintScreen ? classes.lightBulb : classes.puzzle}
						src={isHintScreen ? lightBulbImage: puzzleImage}/>
				</div>
			)
		} else {
			return <div/>
		}
	}
}

AppBarCounter.propTypes = {
	hintCount: PropTypes.number,
	collectedRiddlesAll: PropTypes.number,

	currentScreen: PropTypes.string,

};

export default withStyles(styles)(AppBarCounter);